import React from 'react'
import { Modal } from 'rsuite'
import MasterInformation from '../../AssignVendorComponent/modals/mergeMasterModalComponent/master-information';
import StickyHeader from './sticky-header'

const SupplierInfoModal = ({ show, onClose, supplierData, selectedVendor, onConfirm }) => {
    const handleConfirmClick = () => {
        const masterId = supplierData?.isMaster ? supplierData?.id : supplierData?.masterId
        onConfirm(supplierData?.id, 'Manually Matched Master', masterId)
    }

    return (
        <div>
            <Modal
                backdrop='static'
                className="merge-master-modal supplier-info-modal"
                show={show}
                size="lg"
                onClick={() => { onClose() }}
                onHide={() => { onClose() }}
            >
                <Modal.Header>
                </Modal.Header>
                <Modal.Body>
                    <StickyHeader vendorDetails={selectedVendor} />
                    <div className='d-flex justify-content-end'>
                        <button className='bg-gray mt-5 h4 mb-0 rounded text-white p-5 pt-3 pb-3' onClick={() => { onClose() }}> Go Back </button>
                    </div>
                    <MasterInformation masterDetails={supplierData} isMergeMaster={false} />
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <button className='bg-green h4 mb-0 rounded text-white p-5 pt-3 pb-3' onClick={() => { handleConfirmClick() }}> Confirm </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default SupplierInfoModal